import React from "react";
import { Table } from "react-bootstrap";

const ClientTable = ({ clients }) => {
  const isNonEmpty = (val) =>
  val !== null && val !== undefined && String(val).trim() !== "";

  // Show the Reference column only if at least one client has a non-empty referenceNo
  const showReferenceCol = clients.some((c) => isNonEmpty(c?.referenceNo));

  return (
    <Table bordered hover>
      <thead>
        <tr>
          <th>Client's Name</th>
          <th>BPID</th>
          <th>ISIN</th>
          {showReferenceCol && <th>e-SIP Reference No.</th>}
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        {clients.map((client, index) => (
          <tr key={index}>
            <td>{client.name}</td>
            <td>{client.bpId}</td>
            <td>{client.isin}</td>
            {showReferenceCol && (
                <td>{isNonEmpty(client?.referenceNo) ? client.referenceNo : "—"}</td>
              )}
            <td>{client.amount}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ClientTable;
